import React from "react";
import {
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Table,
} from "reactstrap";

const InvoiceItemsPopover = ({ targetId, items }) => {
  return (
    <UncontrolledPopover
      placement="bottom"
      target={targetId}
      trigger="legacy"
      style={{ maxHeight: "300px", overflowX: "auto", overflowY: "auto" }}
    >
      <PopoverHeader>Invoice Items</PopoverHeader>
      <PopoverBody>
        <Table>
          <thead>
            <tr>
              <th>SN</th>
              <th>Item</th>
              <th>Category</th>
              <th>Price</th>
              <th>QTY</th>
            </tr>
          </thead>
          <tbody>
            {items
              ?.filter((row) => row.item !== "")
              .map((row, ind) => (
                <tr key={ind}>
                  <td style={{ minWidth: "10px" }}>{ind + 1}</td>
                  <td>{row.item}</td>
                  <td>{row.category}</td>
                  <td>{row.unitPrice}</td>
                  <td>{row.quantity}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </PopoverBody>
    </UncontrolledPopover>
  );
};

export default InvoiceItemsPopover;
